module.exports = __webpack_public_path__ + "static/media/icon-loading-widget.e4346d3c.gif";